export default "__VITE_ASSET__DvX$50Li__"